import React, { useContext, useEffect } from "react";
import UserContext from "../context/user";
import { signInWithRedirect } from "aws-amplify/auth";

const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
const COGNITO_REDIRECT = import.meta.env.VITE_COGNITO_REDIRECT;

const PrivateRoute = ({ component: Component }) => {
  const { isLogged } = useContext(UserContext);
  useEffect(() => {
    if (!isLogged) {
      if (!COGNITO_DOMAIN || !COGNITO_REDIRECT) {
        console.error("Missing Cognito domain or redirect config");
        return;
      }
      signInWithRedirect({
        options: {
          lang: "it",
        },
      });
    }
  }, [isLogged]);
  if (!isLogged) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5">
        <span
          className="spinner-border spinner-border-sm mr-1"
          role="status"
          aria-hidden="true"
        ></span>
        Caricamento...
      </div>
    );
  }
  return <>{Component}</>;
};

export default PrivateRoute;
